import { Outlet } from 'react-router';

// Full-width layout for the list/detail/admin screens: content spans the whole
// viewport (screens self-inset with px-6, aligning with the header). RunPage is a
// sibling route with the same full-bleed treatment for its transcript + terminal.
export function ConstrainedLayout() {
  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
}
